import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
} from '@chakra-ui/react';

const FullscreenLoader = () => {
  return (
    <Modal isOpen onClose={() => undefined} size="xs" isCentered>
      <ModalOverlay bg="white" />
      <ModalContent textAlign="center" paddingY="10">
        <ModalBody>
          <Spinner size="xl" color="brand.red.500" />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FullscreenLoader;
